import Keycloak from "keycloak-js";

const HOUSECLAW_GROUP = "houseclaw";

interface TokenWithGroups {
  groups?: unknown;
  group?: unknown;
  scope?: unknown;
}

function normalizeGroup(value: string): string {
  return value.trim().replace(/^\/+/, "").toLowerCase();
}

function hasGroupValue(value: unknown): boolean {
  if (Array.isArray(value)) {
    return value.some(item => normalizeGroup(String(item)) === HOUSECLAW_GROUP);
  }

  if (typeof value === "string") {
    return normalizeGroup(value) === HOUSECLAW_GROUP;
  }

  return false;
}

function hasScopeValue(value: unknown): boolean {
  if (typeof value !== "string") {
    return false;
  }

  return value
    .split(/\s+/)
    .map(scope => scope.trim())
    .some(scope => scope === HOUSECLAW_GROUP);
}

export function hasHouseclawAccess(keycloak: Keycloak): boolean {
  const token = keycloak.tokenParsed as TokenWithGroups | undefined;

  if (!token) {
    return false;
  }

  return hasGroupValue(token.groups) || hasGroupValue(token.group) || hasScopeValue(token.scope);
}
